export default "__VITE_ASSET__Bp_u7erh__"